<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <b-modal id="modalDeleteLanguage" ref="modalDeleteLanguage" title="Confirm">
      <p>Do you really want to remove the registry?</p>
      <p><b>Language: </b> <span v-if="language.language">{{ language.language.description }}</span></p>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="confirmDeleteLanguage">Confirm</b-button>
          <b-button variant="secondary" @click="hideModalDeleteLanguage">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalAddLanguage" ref="modalAddLanguage" size="lg" title="Add language">
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Language <span class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-select v-model="language.languageId" :state="$v.language.languageId.$dirty ? !$v.language.languageId.$error : null" :options="languageOptions" value-field="id" text-field="description"></b-form-select>
            </div>
          </div>
        </b-col>
        <b-col v-if="language.languageId === 99" cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Enter the language <span class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-input v-model="language.other" :state="$v.language.other.$dirty ? !$v.language.other.$error : null"></b-form-input>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-for="(skill) in languageSkillOptions" :key="skill.id" cols="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>{{ skill.description }} Proficiency</label>   
            <div class="input-group">
              <b-form-select v-model="skill.value" :options="languageLevelOptions" value-field="id" text-field="description"></b-form-select>
            </div>
          </div>
        </b-col>
      </b-row>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="saveNewLanguage">Save</b-button>
          <b-button variant="secondary" @click="hideModalAddLanguage">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalEditLanguage" ref="modalEditLanguage" size="lg" title="Edit language">
      <b-row>
        <b-col v-if="language.language" cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Language</label>   
            <p>{{ language.language.description }}</p>
          </div>
        </b-col>
        <b-col v-if="language.languageId === 99" cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Enter the language <span class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-input v-model="language.other" :state="$v.language.other.$dirty ? !$v.language.other.$error : null"></b-form-input>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-for="(skill) in languageSkillOptions" :key="skill.id" cols="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>{{ skill.description }} Proficiency</label>   
            <div class="input-group">
              <b-form-select v-model="skill.value" :options="languageLevelOptions" value-field="id" text-field="description"></b-form-select>
            </div>
          </div>
        </b-col>
      </b-row>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="saveEditLanguage">Save</b-button>
          <b-button variant="secondary" @click="hideModalEditLanguage">Close</b-button>
      </template>
    </b-modal>
    <div class="card-body">
      <h5 class="card-title mt-4">Language</h5>
      <div class="row">
        <div class="col-md-12">
          <b-table hover :items="languages" :fields="languagesFields">
            <template v-slot:cell(description)="row">
              {{ row.item.language.description }} <span v-if="row.item.language.id === 99">({{ row.item.other }})</span>
            </template>
            <template v-slot:cell(languageLevel)="row">
              <span v-for="(item, index) in sortLanguage(row.item.curriculumLanguageSkill)" :key="item.id">
                <template v-if="index !== 0"> / </template>
                <b v-if="item.languageSkill">{{ item.languageSkill.description }}</b>
                <template v-if="item.languageLevel"> {{ item.languageLevel.description }}</template>
              </span>
            </template>
            <template v-slot:cell(Options)="row">
              <b-button v-b-tooltip.hover title="Edit" variant="primary" size="xs" @click="editLanguage(row.item)"><i class="far fa-edit"></i></b-button>
              <b-button v-b-tooltip.hover title="Remove" variant="danger" size="xs" class="ml-2" @click="deleteLanguage(row.item)"><i class="far fa-trash-alt"></i></b-button>
            </template>
          </b-table>
          <b-button variant="primary" @click="addLanguage">Add language</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from '@src/app.config'
import { authMethods } from '@state/helpers'
import loading from 'vue-loading-overlay'
import axios from 'axios'
import 'vue-loading-overlay/dist/vue-loading.css'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

var qs = require('qs')

export default {
  components: { loading },
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    agency: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    id: { type: String, default: () => ({}) }
  },
  data () {
    return {
      CurriculumId: this.id,
      languageOptions: [],
      languageLevelOptions: [],
      languageSkillOptions: [],
      language: {
        curriculumLanguageSkill: []
      },
      languages: [],
      languagesFields: [
        {
          key: 'description',
          label: 'Description'
        },
        {
          key: 'languageLevel',
          label: 'Proficiency'
        },
        {
          key: 'Options',
          label: 'Options',
          thStyle: {width: '120px !important'}
        }
      ],
      isLoading: false,
      fullPage: false,
      zIndex: 9999,
      requiredFields: []
    }
  },
  validations() {
    return {
      language: {
        languageId : { required },
        other: this.language.languageId === 99 ? { required } : {}
      }
    }
  },
  watch: {
    'education.onGoing': {
      handler: function (value) {
        if (value) {
          this.education.endDate = null
        }
      }
    }
  },
  created () {
    this.leadLanguageLevels()
  },
  methods: {
    ...authMethods,
    sortLanguage (arr) {
      return arr.slice().sort(function(a, b) {
        if (a.languageSkill)
          return a.languageSkill.id - b.languageSkill.id;
      })
    },
    leadLanguageLevels () {
      this.isLoading = true
      axios.get(appConfig.apiUrl + 'language/proficiency',
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          if(response.data) {
            this.languageLevelOptions = response.data
          }
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.leadLanguageSkills()
        })
    },
    leadLanguageSkills () {
      this.isLoading = true
      axios.get(appConfig.apiUrl + 'language/skill',
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          if(response.data) {
            this.languageSkillOptions = response.data
            if (this.languageSkillOptions.length > 0) {
              this.languageSkillOptions = this.languageSkillOptions.map(obj => { return { ...obj, value: 1 } })
            }
          }
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.loadLanguages()
        })
    },
    addLanguage () {
      this.isLoading = true
      this.languageSkillOptions = this.languageSkillOptions.map(obj => { return { ...obj, value: 1 } })
      this.language = {
        curriculumLanguageSkill: []
      }
      axios.get(appConfig.apiUrl + 'language/avaible/' + this.CurriculumId,
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          if(response.data) {
            if(response.data.length > 0) {
              this.languageOptions = response.data
              this.$refs['modalAddLanguage'].show()
            } else {
              this.$notify({group: 'alert', type: 'info', title: 'Information', text: 'No have languages avaible.'});
            }
          }
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    saveNewLanguage () {
      this.$v.language.$touch()
      if (this.$v.language.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'});
        return
      }

      this.language.curriculumId = this.CurriculumId

      this.mountSaveLanguage()

      axios.post(appConfig.apiUrl + 'language/save',
        qs.stringify({
          languageSave: this.language
        }),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.'});
          this.loadLanguages()
          this.hideModalAddLanguage()
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    mountSaveLanguage () {
      var _self = this
      _self.language.curriculumLanguageSkill = []
      this.languageSkillOptions.forEach(function (value, index, array) {
        _self.language.curriculumLanguageSkill.push({
          curriculumLanguageId: _self.language.id,
          languageLevelId: value.value,
          languageSkillId: value.id
        })
      })
    },
    hideModalAddLanguage () {
      this.$refs['modalAddLanguage'].hide()
      this.$v.language.$reset()
    },
    editLanguage (item) {
      this.language = item
      this.mountLanguage(item)
      this.$refs['modalEditLanguage'].show()
    },
    mountLanguage (item) {
      this.languageSkillOptions.forEach(function (value, index, array) {
        item.curriculumLanguageSkill.forEach(function (valuex, indexx, arrayx) {
          if (value.id === valuex.languageSkillId) {
            value.value = valuex.languageLevelId
          }
        })
      })
    },
    saveEditLanguage () {
      this.mountSaveLanguage()
      axios.put(appConfig.apiUrl + 'language/update',
        qs.stringify({
          languageSave: this.language
        }),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.'});
          this.loadLanguages()
          this.$emit('reload-curriculum')
          this.hideModalEditLanguage()
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    hideModalEditLanguage () {
      this.$refs['modalEditLanguage'].hide()
      this.$v.language.$reset()
    },
    deleteLanguage (item) {
      this.language = item
      this.$refs['modalDeleteLanguage'].show()
    },
    confirmDeleteLanguage () {
      this.isLoading = true
      axios.post(appConfig.apiUrl + 'language/delete',
        qs.stringify({
          languageSave: {
            id: this.language.id,
            curriculumId: this.language.curriculumId
          }
        }),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Deleted Successful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.loadLanguages()
          this.$emit('reload-curriculum')
          this.isLoading = false
          this.hideModalDeleteLanguage()
        })
    },
    hideModalDeleteLanguage () {
      this.$refs['modalDeleteLanguage'].hide()
    },
    loadLanguages () {
      this.isLoading = true

      axios.get(appConfig.apiUrl + 'language/' + this.CurriculumId,
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          if(response.data) {
            this.languages = response.data
          }
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
